import { ApolloClient, NormalizedCacheObject } from '@apollo/client'
import { RefreshTokenPartner } from '../services/'

type UserToken = {
    token: string
    refreshToken: string
}

type RefreshTokens = {
    access_token: string
    refresh_token: string
}

type RefreshTokenPartnerResponse = {
    refreshTokenPartner: RefreshTokens
}

export async function getTokensPartner(client: ApolloClient<NormalizedCacheObject>, userToken: UserToken) {
    try {
        const { data } = await client.mutate<RefreshTokenPartnerResponse>({
            context: { headers: { authorization: `Bearer ${userToken.token}` } },
            mutation: RefreshTokenPartner,
            variables: { refreshToken: userToken.refreshToken },
        })

        return { accessToken: data?.refreshTokenPartner.access_token, refreshToken: data?.refreshTokenPartner.refresh_token }
    } catch {
        throw new Error('Error getTokensPartner')
    }
}
